import React, { useEffect, useState } from 'react'
import ToastMessage from '../../../../common/ToastMessage';
import CustomDataGrid from '../../../../common/CustomDataGrid';
import useCompanyNews from '../../../../store/ReactQueries/general/companyNews/useCompanyNews';
import useAddCompanyNew from '../../../../store/ReactQueries/general/companyNews/useAddCompanyNew';
import useDeleteCompanyNew from '../../../../store/ReactQueries/general/companyNews/useDeleteCompanyNew';
import useUpdateCompanyNews from '../../../../store/ReactQueries/general/companyNews/useUpdateCompanyNews';
import { GridColDef } from '@mui/x-data-grid';
import { PAGESIZE } from '../../../../utils/constants';
import { FieldErrors } from '../../../../domain/helpers/Errors';
import { formatDate } from '../../../../common/GlobalFunctions';
import { validateSchema } from '../../../../common/ValidateSchema';
import { useLanguageStore } from '../../../../store/useLanguageStore';
import { CompanyNewInterface } from '../../../../models/GeneralModule/CompanyNews';
import { companyNewSchema } from '../../../../domain/ValidationSchemas/GeneralModule/companyNews';

export const CompanyNews = () => {
    const { language } = useLanguageStore();

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [errors, setErrors] = useState<FieldErrors>({});
    const [form, setForm] = useState<CompanyNewInterface>({
        id: '',
        title: '',
        body: '',
        expirationDate: undefined,
    });

    const [modal, setModal] = useState<{ add: boolean, edit: boolean, view: boolean }>({
        add: false,
        edit: false,
        view: false
    });

    let { data: companyNews, error: companyNewError, isLoading } = useCompanyNews();

    const addCompanyNews = useAddCompanyNew();
    const updateCompanyNews = useUpdateCompanyNews();
    const deleteCompanyNews = useDeleteCompanyNew();


    useEffect(() => {
        if (companyNewError) ToastMessage.Failed(`Error: ${companyNewError.message}`);
    }, [companyNewError])

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', type: "string", editable: false, width: 150 },
        { field: 'title', headerName: 'Title', type: "string", editable: true, width: 200 },
        { field: 'body', headerName: 'Body', type: "custom", editable: true, width: 600 },
        { field: 'expirationDate', headerName: 'ExpirationDate', type: "date", editable: false, width: 150, valueFormatter: formatDate },
        { field: 'createdDate', headerName: 'CreatedDate', type: "dateTime", editable: false, width: 150, valueFormatter: formatDate },
        { field: 'updatedDate', headerName: 'UpdatedDate', type: "dateTime", editable: false, width: 150, valueFormatter: formatDate },
        { field: 'authorId', headerName: 'AuthorId', type: "string", editable: false, width: 150 },
        { field: 'modifiedById', headerName: 'ModifiedById', type: "string", editable: false, width: 150 },
    ];

    const addItems = () => {
        setForm({ ...form, title: '', id: '', body: '', expirationDate: undefined });
        setModal({ ...modal, add: true });
        setErrors({});
    }
    const handleError = (error: unknown) => {
        if (error instanceof Error) {
            console.log(error.message);
            ToastMessage.Failed(error.message);
        } else {
            console.log("An unknown error occurred");
            ToastMessage.Failed();
        }
    };

    const handleSave = async () => {
        const isValid = validateSchema(companyNewSchema, form);

        setErrors(isValid.errors);
        if (!isValid.result) return;

        const { id, title, body, expirationDate } = form;

        const upForm: CompanyNewInterface = {
            id,
            title,
            body,
            expirationDate
        };

        if (upForm.id === '') {
            const { id, ...formData } = upForm;
            addCompanyNews.mutate(formData, {
                onSuccess: () => {
                    ToastMessage.Success();
                },
                onError: (error) => handleError(error),
            });
        } else {
            updateCompanyNews.mutate(upForm, {
                onSuccess: () => {
                    ToastMessage.Success()
                },
                onError: (error) => handleError(error),
            });
        }
        setModal({ ...modal, add: false, edit: false, view: false });
    }

    const handleDelete = async (id: string) => {
        if (await ToastMessage.Confirm(language['ToastDeleteItem'])) {
            deleteCompanyNews.mutate(id, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        }
    };

    return (
        <CustomDataGrid
            name={language['CompanyNews']}
            rows={companyNews || []}
            showColumnModal={['title', 'body', 'expirationDate']}
            hideColumns={['authorId', 'id', 'modifiedById']}
            form={form}
            page={page}
            modal={modal}
            errors={errors}
            columns={columns}
            loading={isLoading}
            pageSize={pageSize}
            setForm={setForm}
            setPage={setPage}
            addItems={addItems}
            setModal={setModal}
            setErrors={setErrors}
            handleSave={handleSave}
            setPageSize={setPageSize}
            handleDelete={handleDelete}
        />
    );
}
export default CompanyNews;